import React, {useCallback, useContext, useMemo} from 'react';
import {useFormContext, useWatch} from 'react-hook-form';
import {parseDate, stringifyDate} from '@src/helpers/dates';
import {FormFieldItemPropsContext} from '@src/contexts/FormFieldItemPropsContext';
import DatePicker from '@client/src/components/Fields/DatePicker';
import Translate from '@src/components/Translate/Translate';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import FormErrorMessage from '@src/components/Form/FormErrorMessage';

export default function Calendar({name, label}: {
    rowIndex: number,
    name: string,
    label: string,
}) {
    const {control} = useContext(FormFieldItemPropsContext) ?? {};
    const [{size, fieldsAreDisabled}] = useContext(FormFieldDesignContext);

    const {setValue, clearErrors} = useFormContext();
    const deadlineAtValue = useWatch({control, name: 'deadline_at'});
    const currentDeadlineAtValue = useWatch({control, name});

    const deadlineAt = currentDeadlineAtValue ?? deadlineAtValue;
    const highlightDates = useMemo(() => {
        return deadlineAt ? [{
            'bg-danger text-bg-danger rounded': [parseDate(deadlineAt).toDate()]
        }] : [];
    }, [deadlineAt]);

    const onChange = useCallback((date) => {
        if (!fieldsAreDisabled && date) {
            setValue(name, stringifyDate(date));
            clearErrors(name);
        }
    }, [clearErrors, fieldsAreDisabled, name, setValue]);

    return <>
        <Translate<HTMLLabelElement>
                message={label}
                tag="label"
                className={`col-form-label col-form-label-${size}`}
        />
        <DatePicker
                id={name}
                value={deadlineAt}
                onChange={onChange}
                highlightDates={highlightDates}
                showPopperArrow={false}
                readOnly={true}
                inline={true}
                disabled={fieldsAreDisabled}
                showTimeInput
        />
        <FormErrorMessage fieldName={name} forceDisplaying/>
    </>;
}
